import { IUploadFile } from "../../../../../../../common/services/document-management.service";

export interface ParserPropertyModel {
    propertyName: string;
    propertyType: string;
    apiValidation: boolean;
    requiredValidation: boolean;
}

export interface SampleFileRequest {
    fileType: string;
    model: ParserPropertyModel[];
}

export interface SampleFile {
    data: any;
    fileType: string;
}

export interface ParseFileRequestBase {
	file: IUploadFile;
	fileHasHeaders?: boolean;
}

export interface ParseFileRequest extends ParseFileRequestBase {    
    format: ParserPropertyModel[];
}

export interface BulkWellStatusChangeParseRequest extends ParseFileRequestBase {

}

export interface BulkNAD83UpdateParseRequest extends ParseFileRequestBase {

}

export interface ValidateAPIRequest extends ParseFileRequestBase {
    organizationId: string;
}

export interface ParseProductionDataRequest extends ParseFileRequestBase {
    organizationId: string;
}

export enum ErrorVisibility {
    Any,
    Submitter,
    Reviewer
}

export enum ErrorSeverity {
    Critical,
    Warning
}

export interface ParserError {
    line?: number;
    column?: string;
    error: string;
    visibility: ErrorVisibility;
    severity: ErrorSeverity;
}

export interface ParseFileResponse {
    data: any[];
    errors: ParserError[];
}
